const SetupMoneyManagement = (() => {
  function showDeleteConfirmationPopup(message, callback) {
    const popup = POPUP.build({
      classNames: 'accountClassPopup',
    });

    const messageEle = document.createElement('p');
    messageEle.textContent = message;

    const yesBtn = new Button({
      text: 'Yes',
      style: 'primary',
      styleType: 'contained',
      icon: 'add',
    });
    const noBtn = new Button({
      text: 'No',
      style: 'primary',
      styleType: 'outlined',
      icon: 'add',
    });

    yesBtn.onClick(e => {
      POPUP.close(popup);
      callback(true);
    });
    noBtn.onClick(e => {
      POPUP.close(popup);
      callback(false);
    });

    popup.append(messageEle);
    yesBtn.renderTo(popup);
    noBtn.renderTo(popup);

    POPUP.show(popup);
  }
  // Account Classes
  function showAccountClassPopup(data = {}) {
    const popup = POPUP.build({
      classNames: 'accountClassPopup',
    });

    const accountForm = new Form({
      fields: [
        {
          type: 'text',
          label: 'Class',
          id: 'class',
          required: true,
          value: data.accountClass ?? '',
        },
      ],
    });

    accountForm.onSubmit(async data => {
      const resp = (
        await _UTIL.fetchData('insertAccountClass', {
          accountClass: data.class,
        })
      ).insertAccountClassResult;

      POPUP.hide(popup);
    });
    accountForm.onCancel(() => {
      POPUP.hide(popup);
    });

    accountForm.renderTo(popup);

    POPUP.show(popup);
  }
  function getAccountClassView() {
    const frag = document.createDocumentFragment();

    const accountClassTable = table.build({
      tableId: 'accountClassTable',
      columnHeadings: ['Account Class'],
      endIcon: true,
    });

    const addAccountClassBtn = new Button({
      text: 'Add New Account Class',
      style: 'primary',
      styleType: 'contained',
      icon: 'add',
    });
    addAccountClassBtn.onClick(e => {
      showAccountClassPopup();
    });

    frag.append(accountClassTable);
    if ($.session.SetupUpdate) {
      addAccountClassBtn.renderTo(frag);
    }

    const tableData = moneyManagementPreferencesData.accountClasses.map(account => {
      return {
        values: [account.accountClass],
        endIcon: account.isFinancialAccountClass ? icons['delete'] : '',
        onClick: e => {
          showAccountClassPopup(account);
        },
        endIconCallback: async e => {
          if (!account.isFinancialAccountClass) return;

          showDeleteConfirmationPopup('Are you sure you want to delete this account class?', async deleteRecord => {
            if (deleteRecord) {
              const resp = (
                await _UTIL.fetchData('deleteAccountClass', {
                  accountClass: account.accountClass,
                })
              ).deleteAccountClassResult;
            }
          });
        },
      };
    });

    table.populate(accountClassTable, tableData);

    return frag;
  }

  // Payees
  function checkForExistingPayee(newPayee, newRegionId) {
    let existingPayee = false;

    moneyManagementPreferencesData.payees.forEach(payee => {
      4;
      if (payee.payee === newPayee && payee.region === newRegionId) {
        existingPayee = true;
      }
    });

    return existingPayee;
  }
  function getCategoryDropdownData() {
    const dropdownData = payeesDropdownData.Categories.reduce(
      (acc, category) => {
        acc.categoryData.push({
          text: category.category,
          value: category.categoryId,
        });

        if (category.subCategory) {
          acc.subCategoryData.push({
            text: category.subCategory,
            value: category.categoryId,
          });
        }

        return acc;
      },
      {
        categoryData: [],
        subCategoryData: [],
      },
    );

    return dropdownData;
  }
  function getRegionDropdownData() {
    const dropdownData = payeesDropdownData.Regions.map(reg => {
      return {
        text: reg.region,
        value: reg.regionId,
      };
    });

    return dropdownData;
  }
  function showPayeeListPopup(data = {}) {
    const { categoryData, subCategoryData } = getCategoryDropdownData();
    const regionData = getRegionDropdownData();

    const popup = POPUP.build({
      classNames: 'payeeListPopup',
    });

    const accountForm = new Form({
      fields: [
        {
          type: 'text',
          label: 'Payee',
          id: 'payee',
          required: true,
          value: data.payee,
        },
        {
          type: 'select',
          label: 'Region',
          id: 'region',
          required: true,
          data: regionData,
          value: data.region ?? '',
          includeBlankOption: true,
        },
        {
          type: 'text',
          label: 'Address 1',
          id: 'addressOne',
          required: true,
          value: data.address1,
        },
        {
          type: 'text',
          label: 'Address 2',
          id: 'addressTwo',
          value: data.address2,
        },
        {
          type: 'text',
          label: 'City',
          id: 'city',
          required: true,
          value: data.city,
        },
        {
          type: 'text',
          label: 'State',
          id: 'state',
          required: true,
          value: data.state,
        },
        {
          type: 'text',
          label: 'Zip',
          id: 'zip',
          required: true,
          value: data.zip,
        },
        {
          type: 'select',
          label: 'Category',
          id: 'category',
          required: true,
          data: categoryData,
          value: data.category,
          includeBlankOption: true,
        },
        {
          type: 'select',
          label: 'Subcategory',
          id: 'subcategory',
          required: true,
          data: subCategoryData,
          value: data.subCategroy,
          includeBlankOption: true,
        },
      ],
    });

    // accountForm.onChange(event => {
    //   if (event.target.name === 'payee') {
    //     const payeeAlreadyExists = checkForExistingPayee(data.payee, data.region);

    //     if (payeeAlreadyExists) {
    //       accountForm['payee'].setValidtyError('A payee with this name and region already exists.');
    //       accountForm['payee'].showError('A payee with this name and region already exists.');
    //     } else {
    //       accountForm['payee'].setValidtyError('');
    //       accountForm['payee'].clearErrorOrWarning();
    //     }
    //   }
    // });
    accountForm.onSubmit(async data => {
      const payeeAlreadyExists = checkForExistingPayee(data.payee, data.region);

      if (payeeAlreadyExists) {
        accountForm['payee'].setValidtyError('A payee with this name and region already exists.');
        accountForm['payee'].showError('A payee with this name and region already exists.');
        return;
      }

      accountForm['payee'].setValidtyError('');
      accountForm['payee'].clearErrorOrWarning();

      const resp = (
        await _UTIL.fetchData('insertSetupPagePayee', {
          userId: $.session.UserId,
          description: data.payee,
          regionId: parseInt(data.region),
          address1: data.adressOne,
          adress2: data.adressTwo,
          city: data.city,
          state: data.state,
          zip: data.zip,
          categoryId: data.category,
          subCategoryId: data.subcategory,
        })
      ).insertSetupPagePayeeResult;

      POPUP.hide(popup);
    });
    accountForm.onCancel(() => {
      POPUP.hide(popup);
    });

    accountForm.renderTo(popup);

    POPUP.show(popup);
  }
  function getPayeeListView() {
    const frag = document.createDocumentFragment();

    const payeeListTable = table.build({
      tableId: 'payeeListTable',
      columnHeadings: ['Payee', 'Region', 'Category', 'City'],
      endIcon: true,
    });

    const addPayeeBtn = new Button({
      text: 'Add New Payee',
      style: 'primary',
      styleType: 'contained',
      icon: 'add',
    });
    addPayeeBtn.onClick(e => {
      showPayeeListPopup();
    });

    frag.append(payeeListTable);
    if ($.session.SetupUpdate) {
      addPayeeBtn.renderTo(frag);
    }

    const tableData = moneyManagementPreferencesData.payees
      .sort((a, b) => a.payee.localeCompare(b.payee))
      .map(p => {
        return {
          values: [p.payee, p.region, p.category, p.city],
          endIcon: $.session.SetupDelete ? icons['delete'] : '',
          onClick: e => {
            showPayeeListPopup(p);
          },
          endIconCallback: async e => {
            if (!$.session.SetupDelete) return;

            showDeleteConfirmationPopup('Are you sure you want to delete this payee?', async deleteRecord => {
              const resp = (
                await _UTIL.fetchData('deletePayee', {
                  payee: p.accountClass,
                  region: p.region,
                  category: p.category,
                  city: p.city,
                })
              ).deletePayeeResult;
            });
          },
        };
      });

    table.populate(payeeListTable, tableData);

    return frag;
  }

  function getView(viewName) {
    const viewFragment = document.createDocumentFragment();

    const viewHeading = document.createElement('h1');
    viewHeading.classList.add('viewHeading');
    viewHeading.textContent = `${viewName} System Preferences`;

    const viewBody = document.createElement('div');
    viewBody.classList.add('viewBody');

    let viewMarkup;

    if (viewName === 'Account Classes') {
      viewMarkup = getAccountClassView();
    }
    if (viewName === 'Payees') {
      viewMarkup = getPayeeListView();
    }

    if (viewMarkup) {
      viewFragment.append(viewHeading);
      viewFragment.append(viewBody);
      viewBody.append(viewMarkup);
    }

    return viewFragment;
  }

  function init(data, dropdownData) {
    moneyManagementPreferencesData = data;
    payeesDropdownData = dropdownData.payeesDropdownData;
  }

  return {
    init,
    getView,
  };
})();
